module.exports = __webpack_public_path__ + "media/bootstrap-icons/suit-spade-729ac28b.svg";